import React from "react";
import { Box, Button, Typography } from "@mui/material"
import EmptyStateImage from '../images/empty.png'
import { Link as RouterLink } from 'react-router-dom';

export default () => (
  <Box alignItems="center" display="flex" flexDirection="column">
    <Box textAlign="center" sx={{ maxWidth: '800px' }} margin="4rem 0">
      <Box margin={'2rem'}>
        <img src={EmptyStateImage} height={300} width={300} alt="" />
      </Box>
      <Box margin="1rem 0">
        <Typography variant="h5">Welcome to Fixie!</Typography>
        <Typography>With Fixie, your application can make requests from fixed IP addresses, regardless of how it is hosted.</Typography>
      </Box>
      <Box margin={'2rem'}>
        <Button component={RouterLink} to="/new-app" variant="contained">Create Your First Proxy Application</Button>
      </Box>
    </Box>
  </Box>
)
